import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://aimtyduiwnnnnayzfjyc.supabase.co';
const supabaseKey = 'sb_publishable_vj90ZZm69xB17WxFmmqqbA_fRB-iXng';

export const supabase = createClient(supabaseUrl, supabaseKey);
